module.exports = __webpack_public_path__ + "media/images/mypage/icon/white/ico_pending_request-74638473d8418f37e7a74db056c7e8ef.svg";